import { render, staticRenderFns } from "./CreateGroupModal.vue?vue&type=template&id=65843a6e"
import script from "./CreateGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports